/*
 * Maison Astier - bundle quantity enforcement.
 * The PSP only accepts grid unit prices (<= 49.99). A higher display price is reached by
 * adding N real units of a grid-priced variant. This script keeps each bundle line locked
 * at its N (read from the hidden line property _bundle_qty), so re-adding never stacks above N.
 * The real quantity stays N so checkout charges N x unit = the displayed price.
 */
(function () {
  var origFetch = window.fetch.bind(window);

  function getUrl(args) {
    if (typeof args[0] === 'string') return args[0];
    if (args[0] && args[0].url) return args[0].url;
    return '';
  }

  async function enforceBundleQty() {
    var cart = await origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    var updates = {};
    var changed = false;
    var map = window.MA_BQ || {};
    cart.items.forEach(function (it) {
      var n = map[it.variant_id];
      if (!n) {
        var raw = it.properties && it.properties._bundle_qty;
        if (raw) n = raw;
      }
      n = parseInt(n, 10);
      if (n > 1 && it.quantity !== n) {
        updates[it.key] = n;
        changed = true;
      }
    });
    if (!changed) return false;
    await origFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    });
    return true;
  }

  async function refreshCartUI() {
    if (location.pathname.indexOf('/cart') === 0) {
      location.reload();
      return;
    }
    var wanted = ['cart-drawer', 'cart-icon-bubble', 'cart-notification-product', 'cart-live-region-text'];
    try {
      var data = await origFetch('/?sections=' + wanted.join(',')).then(function (r) { return r.json(); });
      wanted.forEach(function (s) {
        if (!data[s]) return;
        var target = document.getElementById(s) || document.querySelector(s);
        if (!target) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = data[s];
        var fresh = tmp.querySelector('#' + s) || tmp.firstElementChild;
        if (fresh) target.innerHTML = fresh.innerHTML;
      });
    } catch (e) { /* best effort */ }
  }

  window.fetch = function () {
    var args = arguments;
    return origFetch.apply(this, args).then(async function (res) {
      try {
        var url = getUrl(args);
        if (url.indexOf('/cart/add') > -1) {
          var changed = await enforceBundleQty();
          if (changed) await refreshCartUI();
        }
      } catch (e) { /* never block the original response */ }
      return res;
    });
  };

  // On any page load, repair any drifted bundle line silently.
  document.addEventListener('DOMContentLoaded', function () {
    enforceBundleQty().then(function (changed) {
      if (changed && location.pathname.indexOf('/cart') === 0) location.reload();
    });
  });
})();
